import { Component } from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import { Content } from 'ui/sidebar';
import ConversationsSidebar from 'components/ConversationsSidebar';
import { getPlaceConversationsPage } from 'actions/places';
import {
  selectConversationsPagination,
  selectPlaceConversations,
  selectConversation,
} from 'selectors';
import { history } from 'store';
import Breadcrumb from 'components/Breadcrumb';
import { PageHeader, PageHeaderMobileAction, media, spacing } from 'ui';
import { getPathSlug } from 'utils/routes';
import find from 'lodash/find';
import get from 'lodash/get';
import Conversation from './Conversation';
import NewConversation from './NewConversation';
import { MdSettings } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { SERGIC_OFFER } from '../../../constants';

const ConversationsWrapper = styled.div`
  width: 100%;
  position: relative;
  padding-bottom: ${spacing(4)};

  ${media.tablet`
    padding-top: 60px;
    padding-left: 300px;
    padding-bottom: ${spacing(14)};
  `};

  ${media.desktop`
    padding-left: 420px;
  `};

  ${SERGIC_OFFER === 'DIR' &&
    css`
      padding-bottom: ${spacing(7)};
    `};
`;

class Conversations extends Component {
  // componentDidMount() {
  //   this.loadData();
  // }

  componentDidUpdate(prevProps) {
    const { match, ui } = this.props;
    const { selectedPlaceId } = ui;
    const { messageId } = match.params;

    if (
      selectedPlaceId !== prevProps.ui.selectedPlaceId ||
      messageId !== prevProps.match.params.messageId
    ) {
      // this.loadData();
    }

    if (
      prevProps.ui.newConversation &&
      !ui.newConversation &&
      messageId === 'nouveau'
    ) {
      history.push('/mes-echanges/mes-messages');
    }
  }

  // loadData = async () => {
  //   const { getPlaceConversationsPage, ui } = this.props;
  //   const { selectedPlaceId } = ui;

  //   if (!selectedPlaceId) {
  //     return;
  //   }

  //   getPlaceConversationsPage(selectedPlaceId, );
  // };

  render() {
    const { match, conversations } = this.props;
    const { messageId } = match.params;
    let customTranslations = {};

    const conversation = find(
      conversations,
      ({ id }) => Number(id) === Number(messageId),
    );

    if (conversation) {
      customTranslations[getPathSlug(match.url)] = conversation.displayName;
    }

    return (
      <ConversationsWrapper>
        <PageHeader hideOnDesktop>
          <Breadcrumb
            customTranslations={customTranslations}
            subtitle={
              get(conversation, 'members.length') >= 2 &&
              get(conversation, 'members.length')
            }
          />

          <Switch>
            <Route path="/mes-echanges/mes-messages/nouveau" render={null} />
            <Route
              path="/mes-echanges/mes-messages/:id"
              render={({ match }) => (
                <PageHeaderMobileAction as={Link} to={`${match.url}/details`}>
                  <MdSettings />
                </PageHeaderMobileAction>
              )}
            />
          </Switch>
        </PageHeader>

        <ConversationsSidebar hasActiveMessage={Boolean(messageId)} />

        <Content>
          <Switch>
            <Route
              path="/mes-echanges/mes-messages/nouveau"
              component={NewConversation}
            />

            <Route
              path="/mes-echanges/mes-messages/:id/(details)?/:memberId?"
              component={Conversation}
            />
          </Switch>
        </Content>
      </ConversationsWrapper>
    );
  }
}

const mapStateToProps = (state, props) => ({
  ui: state.ui,
  conversations: selectPlaceConversations(state, props),
  pagination: selectConversationsPagination(state, props),
  conversation: selectConversation(state, props),
});

const mapDispatchToProps = dispatch => ({
  getPlaceConversationsPage: (...args) =>
    dispatch(getPlaceConversationsPage(...args)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Conversations),
);
